import React from "react";
import { SearchProps } from "../interfaces/Interfaces";

const SearchBox = ({
  search,
  setSearch,
  error,
  handleKeyDown,
}: SearchProps) => {
  return (
    <div className="flex flex-col justify-center items-center">
      <div className="p-3">
        <input
          type="text"
          max="20"
          role="search"
          alt="Searchbox"
          aria-label="search"
          placeholder={
            error ? "Please enter a valid drink" : "What drink would you like?"
          }
          className={
            error
              ? "p-3 border-black border-2 rounded-md w-60 placeholder-red-600"
              : "p-3 border-black border-2 rounded-md w-60"
          }
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          onKeyDown={(event) => {
            handleKeyDown(event);
          }}
          required
        />
      </div>
    </div>
  );
};

export { SearchBox };
